
import Accordion from '@/ui-kit/components/accordion';
import { AccordionSlotName } from '@/ui-kit/components/accordion/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ListingAccordionHeader from './header';
import ListingAccordionContent from './content';

export default {
  name: 'ListingAccordion',
  components: {
    Accordion,
    ListingAccordionHeader,
    ListingAccordionContent,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    isExpanded: {
      default: false,
      type: Boolean,
    },
    description: {
      default: '',
      type: String,
    },
    characteristicSections: {
      default: () => [],
      type: Array,
    },
    colorScheme: {
      default: StyleColorSchemeType.White,
      type: String,
    },
  },
  data() {
    return {
      AccordionSlotName,
    };
  },
  computed: {
    accordionStatusSettings() {
      return {
        hideText: 'Collapse',
        showText: 'Expand',
      };
    },
  },
};
